import h from 'react-hyperscript';
import styles from './food-section.css';

const FoodSection = () => h('section', {className: styles.foodSectionWrapper}, [
  h('div', {className: styles.foodSectionOverlay}, [
    h('p', '"I gave you guys full marks because not only did I learn something new for myself, but I am now able to teach my family members how to code in order to make a website of their own. These two days have been fantastic and I honestly thought that I would be such a fail at coding, but it turns out that I can do it reasonably well! With practice and with all the tips and tricks I\'ve learnt from Hamzah and Jesh, I hope to create other cool websites and learn other programming software. I definitely recommend people to check out this course because it is something that you will thank yourself later for learning - it is such a useful skill and I am glad I was given the opportunity to learn it as I once thought that programming was exclusively for Computer Science students, but I\'m glad this course was made, because I for one, really enjoyed it! Thank you so much!"'),
    h('p', ' BSc Economics student, University of Birmingham - Code at Uni November 2017')
  ])
]);

export default FoodSection;



/** WEBPACK FOOTER **
 ** ./src/FoodSection/index.js
 **/